import { 
  LineChart as LChart, Line,
  XAxis, YAxis, CartesianGrid, Tooltip,
  Legend,
} from 'recharts';
import { useTheme } from 'styled-components';
import {formatAxisValue,COLORS, getMultiBarColor} from './utils';
import {formatCellValue} from './utils';

const CustomXAxisTick = ({ x, y, payload }: any) => {
  const maxLength = 8;
  const value = payload.value || '';
  const displayText = value.length > maxLength 
    ? value.substring(0, maxLength) + '...' 
    : value;

  return (
    <g transform={`translate(${x},${y})`}>
      <title>{value}</title>
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor="middle"
        fill="#6b7280"
        fontSize={12}
      >
        {displayText}
      </text>
    </g>
  );
};


export const LineChart = ({commonProps,widget }:any) =>{
    const theme = useTheme();
    const statusColors: Record<string, string> = widget.colors;
    const data = commonProps.data || [];

    return (
        <LChart {...commonProps} margin={{ top: 10, right: 15, left:-10, bottom: 10 }}
            barCategoryGap="20%" >
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis dataKey={widget.xKey} stroke="#6b7280" interval={0} tick={<CustomXAxisTick/>}/>
            <YAxis stroke="#6b7280" tickFormatter={formatAxisValue}/>
            
            <Tooltip 
                formatter={(value:any,name:any) => [
                 formatCellValue(value, widget.isPricing === true),  
                null 
                ]}
                itemStyle={{ 
                  color: theme.darkMode ? '#58a6ff' : '#007bff',
                  fontSize: '12px',
                  paddingTop: '4px'
                }}
                labelFormatter={(label) => Array.isArray(widget.dataKey) ? `${widget.xKey}: ${label}` : label } 
                contentStyle={{ 
                  background: theme.darkMode ? '#1a1a1a' : 'white', 
                  color: theme.darkMode ? 'white' : 'black',
                  border: `1px solid ${theme.darkMode ? '#333' : '#e5e7eb'}`,
                  borderRadius: '8px',
                  fontSize: '12px'
                }}
            />

            {Array.isArray(widget.dataKey) ? <Legend /> : null}

            {Array.isArray(widget.dataKey) ? (
                widget.dataKey.map((key:any, idx:any) => 
                (<Line 
                    key={key}
                    type="monotone" 
                    dataKey={key} 
                    stroke={getMultiBarColor(statusColors,key,data[idx],widget.fields,idx)} 
                    strokeWidth={2}
                    dot={{ r: 4 }}
                    activeDot={{ r: 6 }}
                />
                )
              )
            ) : (
                <Line 
                type="monotone" 
                dataKey={widget.valueKey} 
                stroke={COLORS[0]} 
                strokeWidth={2}
                dot={{ r: 4 }}
                activeDot={{ r: 6 }}
                />
            )}
        </LChart>
    )

}